import React from 'react';

const CustomerCharter = () => {
  return (
    <section className='px-6 sm:px-10 xl:px-59 pb-12 md:pb-16 xl:pb-24 2xl:pb-28 mt-28 sm:mt-40'>
      <div className='w-full sm:w-1/2'>
        <h1 className='font-tobias text-2xl sm:text-3xl lg:text-4xl xl:text-40 2xl:text-5xl text-gableGreen'>Customer Charter</h1>
        <div className="mt-8">
          <p className={`${text} mt-4`}>
            At Intrapac Property, our team is committed to providing our customers with the highest quality of service. We value our customer's trust and satisfaction, and we aim to exceed your expectations across all aspects of our business.
          </p>

          <p className={`${text} mt-4`}>Our Customer Charter details our promises and obligations to you, along with your rights and responsibilities as a customer:</p>

          <ul className="mt-4">
            <li className={`${text}`}>We respect and value our customers and treat them with courtesy and professionalism.</li>
            <li className={`${text} mt-2`}>We listen to our customers and understand their needs and preferences.</li>
            <li className={`${text} mt-2`}>We maintain clear and transparent communication with our customers and keep them informed throughout the process.</li>
            <li className={`${text} mt-2`}>We deliver high-quality products and service that meet or exceed our customers' expectations.</li>
            <li className={`${text} mt-2`}>We uphold our commitments and promises.</li>
            <li className={`${text} mt-2`}>We operate with integrity and honesty and comply with all relevant laws and regulations.</li>
            <li className={`${text} mt-2`}>We welcome feedback from customers to enhance our performance and satisfaction.</li>
            <li className={`${text} mt-2`}>We address complaints and disputes promptly and fairly, working towards swift resolution.</li>
          </ul>

          <h2 className='font-mori text-base sm:text-lg lg:text-xl xl:text-2xl font-medium text-gableGreen mt-8'>Our Commitment to you</h2>
          <p className={`${text} mt-4`}>
            Our service goals are a set of specific and measurable objectives to ensure fulfillment of our Customer Charter. We monitor and report on our performance against these goals regularly and take necessary corrective measures if we do not meet them.
          </p>

          <h3 className='font-mori text-sm sm:text-base lg:text-lg font-medium text-gableGreen mt-6'>Customer Enquiries:</h3>
          <ul className="mt-3">
            <li className={`${text}`}>We commit to responding to customer inquiries within two business days</li>
            <li className={`${text} mt-2`}>We will treat you with respect, providing fair, unbiased and personalised service</li>
            <li className={`${text} mt-2`}>We will aim to resolve your enquiry at the first point of contact. If the matter requires further investigation we will provide you with an update within five business days.</li>
          </ul>

          <h3 className='font-mori text-sm sm:text-base lg:text-lg font-medium text-gableGreen mt-6'>Customer Feedback:</h3>
          <ul className="mt-3">
            <li className={`${text}`}>We will invite you to participate in a customer satisfaction survey after settlement of your purchase.</li>
            <li className={`${text} mt-2`}>We welcome your feedback and comments on our service so we can continuously improve our commitment to our customers</li>
          </ul>

          <h3 className='font-mori text-sm sm:text-base lg:text-lg font-medium text-gableGreen mt-6'>Product Quality and Delivery:</h3>
          <ul className="mt-3">
            <li className={`${text}`}>We commit to providing you with precise and realistic timelines for construction and completion.</li>
            <li className={`${text} mt-2`}>Provide monthly updates of the construction of your lot during the civil construction period.</li>
            <li className={`${text} mt-2`}>We are committed to conducting regular inspections and audits of our products and processes to ensure compliance and maintain high quality.</li>
            <li className={`${text} mt-2`}>We are committed to deliver your product according to the agreed specifications.</li>
          </ul>

          <h3 className='font-mori text-sm sm:text-base lg:text-lg font-medium text-gableGreen mt-6'>Complaints and Disputes:</h3>
          <ul className="mt-3">
            <li className={`${text}`}>We will address your complaint or dispute within two business days, setting out clear expectations and commitments for the next steps.</li>
            <li className={`${text} mt-2`}>Once acknowledged, we will provide you with a reference number and assign a specific contact person.</li>
            <li className={`${text} mt-2`}>Our goal is to efficiently resolve any issues at your initial point of contact, based on the nature of the problem.</li>
            <li className={`${text} mt-2`}>If further investigation is necessary, we will conduct a thorough review and respond with a resolution or action plan (if needed) within 10 business days.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

const text = 'font-mori text-xs lg:text-sm xl:text-base text-gableGreen mt-2';

export default CustomerCharter;